import { SVGIconProps } from "@faire/slate-icons/types";
import React from "react";

type IProps = {
  Icon?: React.FC<SVGIconProps>;

  label?: string;
};

export const MenuItemContent: React.FC<IProps> = ({ Icon, label }) => {
  return (
    <span className="fs-menu__item-content">
      {Icon ? (
        <span className="fs-menu__item-icon">
          <Icon titleAccess="" />
        </span>
      ) : null}
      <span>{label}</span>
    </span>
  );
};
